import React from "react";

const ErrorPage = ({ type = "app", status, onRetry }) => {
  let title = "Something Went Wrong";
  let message =
    "Something unexpected happened. Please try again.";

  if (type === "network") {
    title = "Unable to Connect";
    message =
      "We couldn't connect to the server. Please check your internet connection and try again.";
  }

  if (type === "server") {
    title = "Server Unavailable";
    message =
      "We're having trouble connecting to the application server. Please try again after some time.";
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f7fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          textAlign: "center",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          padding: "45px 35px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            margin: "0 auto 25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(to right, #3b409e, #0098d5)",
            color: "white",
            fontSize: "38px",
            fontWeight: "bold",
          }}
        >
          !
        </div>

        <h2
          style={{
            marginBottom: "15px",
            fontWeight: "700",
            color: "#333",
          }}
        >
          {title}
        </h2>

        <p
          style={{
            color: "#666",
            fontSize: "15px",
            lineHeight: "1.6",
            marginBottom: "25px",
          }}
        >
          {message}
        </p>

        {status !== undefined && status !== null && (
          <p
            style={{
              fontSize: "12px",
              color: "#999",
              marginBottom: "20px",
            }}
          >
            Please try again or contact support if the problem continues.
          </p>
        )}

        <button
          onClick={onRetry || (() => window.location.reload())}
          style={{
            border: "none",
            borderRadius: "8px",
            padding: "11px 30px",
            color: "white",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
            background:
              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
          }}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;